import { render, staticRenderFns } from "./BillHederDialog.vue?vue&type=template&id=e7b66724"
import script from "./BillHederDialog.vue?vue&type=script&lang=js"
export * from "./BillHederDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports